import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import type { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'
import { mapActivityPartToSelectableListMenuData } from './utils/mapActivityPartToSelectableListMenuData'

export type SelectableListMenuDataWithMetadata = {
  metadata?: { activityPart: FrontActivityPart<FrontActivityWithAggregate> }
  id: string
  name: string
  children: SelectableListMenuDataWithMetadata[]
}

interface TOCMenuState {
  pluginEnabled: boolean
  tocItems:
    | (SelectableListMenuDataWithMetadata & { root: { name?: string; progress?: number; dueDate?: string } | null })
    | null
}

const initialState: TOCMenuState = {
  pluginEnabled: false,
  tocItems: null,
}

export const tocMenuSlice = createSlice({
  name: 'tocMenu',
  initialState,
  reducers: {
    setTocPluginEnabled(state, { payload }: PayloadAction<boolean>) {
      state.pluginEnabled = payload

      if (!payload) {
        state.tocItems = null
      }
    },
    setTocItems(
      state,
      {
        payload,
      }: PayloadAction<{
        root: { name?: string; progress?: number } | null
        children: FrontActivityPart<FrontActivityWithAggregate>[]
      }>,
    ) {
      const mapped = {
        name: 'root',
        id: 'root',
        root: payload.root,
        children: (payload.children ?? []).map(mapActivityPartToSelectableListMenuData),
      }

      state.tocItems = mapped
    },
  },
})

export const { setTocPluginEnabled, setTocItems } = tocMenuSlice.actions

export default tocMenuSlice.reducer
